import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import moment from 'moment'

export interface AuditState {
  auditList?: unknown
  reloadAuditList?: string | null
}

const initialState: AuditState = {
  auditList: {},
  reloadAuditList: null,
}

export const auditDucks = createSlice({
  name: 'audit',
  initialState,
  reducers: {
    getListAudit: (state, action: PayloadAction<string | undefined>) => {
      state.auditList = { loading: true, queryStr: action.payload }
    },
    getListAuditSuccess: (state, action: PayloadAction<unknown>) => {
      state.auditList = { loading: false, ...(action.payload as object) }
    },
    getListAuditFail: (state, action: PayloadAction<unknown>) => {
      state.auditList = { loading: false, ...(action.payload as object) }
    },
    setReloadAuditList: (state) => {
      state.reloadAuditList = String(moment())
    },
  },
})

export const { getListAudit, getListAuditSuccess, getListAuditFail, setReloadAuditList } = auditDucks.actions

export default auditDucks.reducer
